(() => {
	const topMenuLogins = document.querySelectorAll('.topmenu__link--login');

	if(topMenuLogins.length) {
		topMenuLogins.forEach(topMenuLogin => {
			topMenuLogin.addEventListener('click', e => {
				e.preventDefault();
				window.EventBus.$emit('open-modal', 'login');
			});
		});
	}
})();